import {
  UNLOCK_IMEI,
  UNLOCK_IMEI_ERROR,
  CLEAN_UNLOCK_IMEI,
  CLEAN_UNLOCK_IMEI_ERROR,
} from '_models/redux/types';

const initialState = {
  response: [],
  loading: false,
};

export default function unlockImeiReducer(state = initialState, action) {
  switch (action.type) {
    case UNLOCK_IMEI:
    case CLEAN_UNLOCK_IMEI:
      return {
        ...state,
        response: action.payload,
        loading: true,
      };

    case UNLOCK_IMEI_ERROR:
    case CLEAN_UNLOCK_IMEI_ERROR:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    default:
      return state;
  }
}
